import * as types from "src/store/types/usuarios";

const INITIAL_STATE = {
  loading: false,
  usuarios: [],
  usuarios_page: 1,
  usuarios_perpage: 10,
  usuarios_total: 0,
  usuarios_filtro: {
    nome: "",
    situacao: "A",
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.USUARIOS_LOADING:
      return { ...state, usuarios_loading: action.payload };
    case types.USUARIOS_SET_USUARIOS:
      return { ...state, usuarios: action.payload };
    case types.USUARIOS_SET_PAGE:
      return { ...state, usuarios_page: action.payload };
    case types.USUARIOS_SET_PERPAGE:
      return { ...state, usuarios_perpage: action.payload };
    case types.USUARIOS_SET_TOTAL:
      return { ...state, usuarios_total: action.payload };
    case types.USUARIOS_SET_FILTRO:
      return {
        ...state,
        usuarios_filtro: { ...state.usuarios_filtro, ...action.payload },
      };
    default:
      return state;
  }
};
